import React from 'react';
import { useTranslation } from "react-i18next";

const MobileAppSectionTitle = () => {
    const { t } = useTranslation();
    
    return (
        <div className="mobileAppSectionTitle__container">
            <div className="mobileAppSectionTitle__container-wrap">
                <div className="mobileAppSectionTitle__container-title-wrap">
                    <div className="mobileAppSectionTitle__container-title-text">
                        <span>{t('navbar.mobileApp')}</span>
                    </div>
                </div>
                <div className="mobileAppSectionTitle__container-subtitle-wrap">
                    <div className="mobileAppSectionTitle__container-subtitle-text">
                        <span>{t('main.youCanFindOffersMobileApp')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileAppSectionTitle;